import { render, staticRenderFns } from "./FacebookStat.vue?vue&type=template&id=6f2b43d7&"
import script from "./FacebookStat.vue?vue&type=script&lang=js&"
export * from "./FacebookStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports